<div class="auth-container">
  <div class="auth-content">
    <div class="auth-card">
      <div class="auth-card-header">
        <img class="logo" src="assets/images/logo.png" alt="logo" />
      </div>

      <div class="auth-card-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
